import React, { useState } from 'react';
import './App.css';

// Minimal SVG Icons
const Icon = {
  Phone: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>,
  Calendar: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  BarChart: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  Link: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg>,
  Shield: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  Target: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>,
  Check: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>,
  Zap: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
  Mic: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/><path d="M19 10v2a7 7 0 01-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>,
  Building: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01M16 6h.01M8 10h.01M16 10h.01M8 14h.01M16 14h.01"/></svg>,
  Home: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  Wrench: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>,
  Book: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>,
  ShoppingBag: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>,
  Scale: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="3" x2="12" y2="21"/><polyline points="8 8 4 12 8 16"/><polyline points="16 16 20 12 16 8"/></svg>,
  Coffee: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8h1a4 4 0 010 8h-1"/><path d="M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>,
  Briefcase: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>,
  Lock: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>,
  Server: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="8" rx="2"/><rect x="2" y="14" width="20" height="8" rx="2"/><line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/></svg>,
  Activity: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  Star: () => <svg viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
};

function App() {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', company: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch('https://script.google.com/macros/s/AKfycbxBQemK0GAakifzGwO0jlTgdwWP9Tp6m1iv2veBV6k5hlo7t5PV1aCbA4ja3A0v6UYIHA/exec', {
        method: 'POST', mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, timestamp: new Date().toLocaleString() }),
      });
      setSubmitted(true);
      setFormData({ name: '', email: '', phone: '', company: '', message: '' });
    } catch (err) { console.error(err); }
  };

  const languages = [
    { name: 'Hindi', native: 'हिंदी' }, { name: 'English', native: 'Indian English' },
    { name: 'Tamil', native: 'தமிழ்' }, { name: 'Telugu', native: 'తెలుగు' },
    { name: 'Kannada', native: 'ಕನ್ನಡ' }, { name: 'Malayalam', native: 'മലയാളം' },
    { name: 'Marathi', native: 'मराठी' }, { name: 'Bengali', native: 'বাংলা' },
    { name: 'Gujarati', native: 'ગુજરાતી' }, { name: 'Punjabi', native: 'ਪੰਜਾਬੀ' },
    { name: 'Odia', native: 'ଓଡ଼ିଆ' }, { name: 'More', native: 'Coming soon' },
  ];

  const industries = [
    { name: 'Healthcare', desc: 'Clinics, Hospitals, Labs', stat: '+45% bookings', Ico: Icon.Building },
    { name: 'Real Estate', desc: 'Brokers, Builders', stat: '3× faster response', Ico: Icon.Home },
    { name: 'Home Services', desc: 'AC, Plumbing, Electric', stat: 'Zero missed calls', Ico: Icon.Wrench },
    { name: 'Education', desc: 'Coaching, Schools', stat: '24/7 inquiries', Ico: Icon.Book },
    { name: 'E-commerce', desc: 'D2C, Marketplaces', stat: '70% automated', Ico: Icon.ShoppingBag },
    { name: 'Legal & Finance', desc: 'CA, Law, Insurance', stat: '80% admin saved', Ico: Icon.Scale },
    { name: 'Restaurants', desc: 'QSR, Cloud Kitchens', stat: 'Order handling', Ico: Icon.Coffee },
    { name: 'Enterprise', desc: 'Custom solutions', stat: 'Contact us', Ico: Icon.Briefcase },
  ];

  return (
    <div className="App">
      {/* Navbar */}
      <nav className="navbar">
        <div className="container">
          <a href="#home" className="logo"><img src="/logo.png" alt="BizAI" className="logo-img" /></a>
          <div className="nav-links">
            <a href="#features">Features</a>
            <a href="#languages">Languages</a>
            <a href="#pricing">Pricing</a>
            <a href="#contact" className="nav-cta">Get a quote</a>
          </div>
          <button className={`mobile-menu-btn ${mobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu} aria-label="Menu">
            <span></span><span></span><span></span>
          </button>
        </div>
      </nav>

      {/* Mobile Navigation */}
      <div className={`mobile-nav-overlay ${mobileMenuOpen ? 'active' : ''}`} onClick={closeMobileMenu}></div>
      <div className={`mobile-nav ${mobileMenuOpen ? 'active' : ''}`}>
        <a href="#features" onClick={closeMobileMenu}>Features</a>
        <a href="#languages" onClick={closeMobileMenu}>Languages</a>
        <a href="#pricing" onClick={closeMobileMenu}>Pricing</a>
        <a href="#demo" onClick={closeMobileMenu}>Demo</a>
        <a href="#contact" onClick={closeMobileMenu} className="nav-cta">Get a quote</a>
      </div>

      {/* Hero */}
      <section id="home" className="hero">
        <div className="container">
          <div className="hero-grid">
            <div className="hero-content">
              <div className="hero-eyebrow"><span className="dot"></span>Voice AI for India</div>
              <h1>Your voice agent,<br/><span className="gradient">speaking India</span></h1>
              <p className="hero-desc">Production-grade voice AI for calls in Hindi, Tamil, Telugu and 10+ Indian languages. Built for scale, optimized for Indian accents.</p>
              <div className="hero-actions">
                <a href="#contact" className="btn btn-primary">Get a quote</a>
                <a href="#demo" className="btn btn-ghost">Try live demo</a>
              </div>
              <div className="hero-stats">
                <div className="stat"><span className="stat-value">50K+</span><span className="stat-label">calls handled</span></div>
                <div className="stat"><span className="stat-value">12+</span><span className="stat-label">languages</span></div>
                <div className="stat"><span className="stat-value">&lt;800ms</span><span className="stat-label">latency</span></div>
              </div>
            </div>

            {/* Console Preview */}
            <div className="console-preview">
              <div className="console-frame">
                <div className="console-titlebar">
                  <div className="console-titlebar-left">
                    <div className="window-controls"><span></span><span></span><span></span></div>
                    <span className="console-title">BizAI Console</span>
                  </div>
                  <div className="status-pill">Live</div>
                </div>
                <div className="console-body">
                  <div className="metrics-row">
                    <div className="metric-tile"><div className="metric-tile-label">Calls Today</div><div className="metric-tile-value">247</div><div className="metric-tile-delta">↑ 18%</div></div>
                    <div className="metric-tile"><div className="metric-tile-label">Booking Rate</div><div className="metric-tile-value emerald">36%</div><div className="metric-tile-delta">↑ 4.2 pts</div></div>
                    <div className="metric-tile"><div className="metric-tile-label">Avg Latency</div><div className="metric-tile-value accent">680ms</div><div className="metric-tile-delta">↓ 120ms</div></div>
                  </div>
                  <div className="signals-panel">
                    <div className="signals-header"><span className="signals-header-title">Production Signals</span><span className="signals-header-count">3 active</span></div>
                    <div className="signal-item">
                      <div className="signal-icon-wrap"><Icon.Calendar /></div>
                      <div className="signal-body"><div className="signal-title">Appointment confirmed via Hindi</div><div className="signal-meta">Dr. Sharma Clinic · 2m ago</div></div>
                      <span className="signal-tag emerald">Booked</span>
                    </div>
                    <div className="signal-item">
                      <div className="signal-icon-wrap"><Icon.Zap /></div>
                      <div className="signal-body"><div className="signal-title">Lead qualified — high intent</div><div className="signal-meta">Mumbai Real Estate · 5m ago</div></div>
                      <span className="signal-tag rose">Hot</span>
                    </div>
                    <div className="signal-item">
                      <div className="signal-icon-wrap"><Icon.Phone /></div>
                      <div className="signal-body"><div className="signal-title">Tamil inquiry — routed to agent</div><div className="signal-meta">Chennai Dental · 8m ago</div></div>
                      <span className="signal-tag amber">Escalate</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Logos */}
      <section className="logos-section">
        <div className="container">
          <p className="logos-label">Trusted by businesses across India</p>
          <div className="logos-row">
            <span>Apollo Health</span><span>Urban Company</span><span>Practo</span><span>Zoho</span><span>Housing.com</span>
          </div>
        </div>
      </section>

      {/* Languages */}
      <section id="languages" className="section">
        <div className="container">
          <div className="section-header">
            <div className="section-eyebrow">Languages</div>
            <h2>Built for India's diversity</h2>
            <p>Native support for 12+ Indian languages with regional accent understanding</p>
          </div>
          <div className="languages-grid">
            {languages.map((l, i) => (
              <div className="lang-card" key={i}><div className="lang-icon"><Icon.Mic /></div><h4>{l.name}</h4><p>{l.native}</p></div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section id="features" className="section">
        <div className="container">
          <div className="section-header">
            <div className="section-eyebrow">Platform</div>
            <h2>Complete voice AI infrastructure</h2>
            <p>Everything you need to deploy production voice agents</p>
          </div>
          <div className="bento-grid">
            <div className="bento-card col-8">
              <div className="bento-icon"><Icon.Phone /></div>
              <h3>24/7 AI Receptionist</h3>
              <p>Instant call pickup in any Indian language. Handles inquiries, books appointments, qualifies leads.</p>
              <ul className="check-list">
                <li><span className="check-icon"><Icon.Check /></span>Sub-second response time</li>
                <li><span className="check-icon"><Icon.Check /></span>Natural conversation flow</li>
                <li><span className="check-icon"><Icon.Check /></span>Smart escalation to humans</li>
              </ul>
            </div>
            <div className="bento-card col-4 row-2">
              <div className="bento-icon"><Icon.Link /></div>
              <h3>One-click integrations</h3>
              <p>Connect with your existing stack.</p>
              <div className="code-block">
                <div className="code-tabs"><span className="code-tab active">Python</span><span className="code-tab">cURL</span></div>
                <div className="code-content">
                  <span className="kw">from</span> bizai <span className="kw">import</span> Agent<br/><br/>
                  <span className="cm"># Initialize</span><br/>
                  agent = Agent(<br/>
                  &nbsp;&nbsp;lang=<span className="str">"hi-IN"</span>,<br/>
                  &nbsp;&nbsp;voice=<span className="str">"priya"</span><br/>
                  )<br/><br/>
                  agent.<span className="fn">handle_call</span>()
                </div>
              </div>
            </div>
            <div className="bento-card col-4"><div className="bento-icon"><Icon.BarChart /></div><h3>Real-time analytics</h3><p>Every call, every conversion, every insight. Make data-driven decisions.</p></div>
            <div className="bento-card col-4"><div className="bento-icon"><Icon.Target /></div><h3>Lead scoring</h3><p>AI identifies high-intent prospects and routes them instantly.</p></div>
            <div className="bento-card col-6"><div className="bento-icon"><Icon.Calendar /></div><h3>Smart scheduling</h3><p>Syncs with Google Calendar, Zoho, sends automatic SMS reminders. Reduce no-shows by 60%.</p></div>
            <div className="bento-card col-6"><div className="bento-icon"><Icon.Shield /></div><h3>Enterprise security</h3><p>DPDP compliant, data hosted in India (AWS Mumbai), end-to-end encryption.</p></div>
          </div>
        </div>
      </section>

      {/* Demo */}
      <section id="demo" className="section">
        <div className="container">
          <div className="demo-grid">
            <div className="demo-content">
              <div className="section-eyebrow">Live Demo</div>
              <h2>Hear how BizAI sounds in production</h2>
              <p>Call our demo agent right now. Have a real conversation in Hindi or English.</p>
              <ul className="demo-list">
                <li><span className="icon-wrap"><Icon.Zap /></span>Sub-second response latency</li>
                <li><span className="icon-wrap"><Icon.Mic /></span>Natural Hindi & English voices</li>
                <li><span className="icon-wrap"><Icon.Target /></span>Context-aware conversations</li>
                <li><span className="icon-wrap"><Icon.Phone /></span>No app download required</li>
              </ul>
            </div>
            <div className="demo-card">
              <div className="demo-icon-circle"><Icon.Phone /></div>
              <h3>Try it now</h3>
              <a href="tel:+914699100360" className="demo-phone">+91 469 910 0360</a>
              <p className="demo-note">Available 24/7 · Free · No signup</p>
            </div>
          </div>
        </div>
      </section>

      {/* Industries */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <div className="section-eyebrow">Industries</div>
            <h2>Built for Indian businesses</h2>
            <p>From local clinics to enterprise chains</p>
          </div>
          <div className="industries-grid">
            {industries.map((ind, i) => (
              <div className="industry-card" key={i}><div className="industry-icon"><ind.Ico /></div><h3>{ind.name}</h3><p>{ind.desc}</p><span className="industry-stat">{ind.stat}</span></div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust */}
      <section className="trust-section">
        <div className="container">
          <div className="trust-row">
            <div className="trust-item"><div className="trust-icon"><Icon.Lock /></div><div className="trust-text"><h4>DPDP Compliant</h4><p>India data protection</p></div></div>
            <div className="trust-item"><div className="trust-icon"><Icon.Shield /></div><div className="trust-text"><h4>ISO 27001</h4><p>Security certified</p></div></div>
            <div className="trust-item"><div className="trust-icon"><Icon.Server /></div><div className="trust-text"><h4>AWS Mumbai</h4><p>India-hosted</p></div></div>
            <div className="trust-item"><div className="trust-icon"><Icon.Activity /></div><div className="trust-text"><h4>99.9% Uptime</h4><p>Enterprise SLA</p></div></div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="section">
        <div className="container">
          <div className="section-header"><div className="section-eyebrow">Results</div><h2>What our clients say</h2><p>Real results from Indian businesses</p></div>
          <div className="testimonials-grid">
            {[
              { text: "We recovered 47 missed calls in the first month. That's ₹7.8 lakhs in revenue. The AI handles Hindi perfectly.", stat: "+₹7.8L recovered", name: "Dr. Sunita Sharma", role: "Smile Dental, Mumbai", ini: "DS" },
              { text: "No-show rate dropped from 22% to 8%. Tamil support was a game-changer for our Chennai patients.", stat: "63% fewer no-shows", name: "Dr. Rajesh Kumar", role: "Apollo Partner, Chennai", ini: "RK" },
              { text: "200+ service calls daily—impossible to handle manually. BizAI does scheduling, follow-ups, even payment reminders.", stat: "200+ calls/day", name: "Amit Patel", role: "UrbanClap Partner, Ahmedabad", ini: "AP" },
            ].map((t, i) => (
              <div className="testimonial-card" key={i}>
                <div className="testimonial-rating">{[...Array(5)].map((_, j) => <Icon.Star key={j} />)}</div>
                <p className="testimonial-text">"{t.text}"</p>
                <div className="testimonial-stat">{t.stat}</div>
                <div className="testimonial-author"><div className="author-avatar">{t.ini}</div><div className="author-info"><h4>{t.name}</h4><p>{t.role}</p></div></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section id="pricing" className="section pricing-section">
        <div className="container">
          <div className="section-header">
            <div className="section-eyebrow">Pricing</div>
            <h2>Pay only for what you use</h2>
            <p>Pay-as-you-go pricing. Minimum 1000 minutes/month commitment.</p>
          </div>
          
          <div className="pricing-highlight">
            <div className="pricing-highlight-badge">Cheapest & Best Quality</div>
            <div className="pricing-hero-card">
              <div className="pricing-hero-label">Per Minute Rate</div>
              <div className="pricing-hero-value">
                <span className="currency">₹</span>
                <span className="amount">3.5</span>
                <span className="unit">/min</span>
              </div>
              <p className="pricing-hero-desc">Inbound + Outbound calls. Min 1000 min/month (₹3,500/mo).</p>
              <div className="pricing-addon">
                <span className="pricing-addon-label">₹1,000/channel</span>
                <span className="pricing-addon-text">+ setup cost based on your use case</span>
              </div>
            </div>
          </div>

          <div className="pricing-features-grid">
            <div className="pricing-feature-item">
              <div className="pricing-feature-icon"><Icon.Check /></div>
              <div className="pricing-feature-text">
                <h4>Min 1000 min/month</h4>
                <p>Starting at just ₹3,500/month</p>
              </div>
            </div>
            <div className="pricing-feature-item">
              <div className="pricing-feature-icon"><Icon.Check /></div>
              <div className="pricing-feature-text">
                <h4>All 12+ languages included</h4>
                <p>Hindi, Tamil, Telugu, and more at same rate</p>
              </div>
            </div>
            <div className="pricing-feature-item">
              <div className="pricing-feature-icon"><Icon.Check /></div>
              <div className="pricing-feature-text">
                <h4>Free integrations</h4>
                <p>Calendar, CRM, SMS — no extra cost</p>
              </div>
            </div>
            <div className="pricing-feature-item">
              <div className="pricing-feature-icon"><Icon.Check /></div>
              <div className="pricing-feature-text">
                <h4>24/7 support</h4>
                <p>Help when you need it, included free</p>
              </div>
            </div>
          </div>

          <div className="pricing-cta">
            <a href="#contact" className="btn btn-primary">Start free trial</a>
            <p className="pricing-note">No credit card required · Setup in 48 hours</p>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="section">
        <div className="container">
          {!submitted ? (
            <>
              <div className="section-header"><div className="section-eyebrow">Get Started</div><h2>Get a quote</h2><p>Setup in under 48 hours</p></div>
              <div className="contact-wrapper">
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <input type="text" name="name" placeholder="Name" value={formData.name} onChange={handleChange} required />
                    <input type="email" name="email" placeholder="Work email" value={formData.email} onChange={handleChange} required />
                  </div>
                  <div className="form-row">
                    <input type="tel" name="phone" placeholder="Phone" value={formData.phone} onChange={handleChange} required />
                    <input type="text" name="company" placeholder="Company" value={formData.company} onChange={handleChange} required />
                  </div>
                  <textarea name="message" placeholder="Tell us about your use case" value={formData.message} onChange={handleChange} rows="4" />
                  <button type="submit" className="submit-btn">Get a quote</button>
                </form>
              </div>
            </>
          ) : (
            <div className="thankyou-wrapper">
              <div className="thankyou-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
              </div>
              <h2>Thank you!</h2>
              <p>We've received your request. Our team will contact you within 24 hours with a customized quote.</p>
              <a href="#home" className="btn btn-primary" onClick={() => setSubmitted(false)}>Back to home</a>
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand"><a href="#home" className="logo"><img src="/logo.png" alt="BizAI" className="logo-img" /></a><p>Production-grade voice AI infrastructure for Indian businesses.</p></div>
            <div className="footer-col"><h4>Product</h4><a href="#features">Features</a><a href="#languages">Languages</a><a href="#pricing">Pricing</a><a href="#demo">Demo</a></div>
            <div className="footer-col"><h4>Industries</h4><a href="#industries">Healthcare</a><a href="#industries">Real Estate</a><a href="#industries">E-commerce</a><a href="#industries">Enterprise</a></div>
            <div className="footer-col"><h4>Contact</h4><p>hello@bizailabs.com</p><p>Delhi, India</p></div>
          </div>
          <div className="footer-bottom">© 2026 BizAI Labs · Made in India</div>
        </div>
      </footer>
    </div>
  );
}

export default App;
